var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgICloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90696 12.3331C9.16569 12.3331 10.1861 11.2885 10.1861 9.99986C10.1861 8.71124 9.16569 7.66661 7.90696 7.66661C6.64823 7.66661 5.62782 8.71124 5.62782 9.99986C5.62782 11.2885 6.64823 12.3331 7.90696 12.3331Z",
    fill: "url(#paint0_linear_1310_6464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.1666C18 10.6019 16.761 9.33321 15.2325 9.33321C13.7039 9.33321 12.4649 10.6019 12.4649 12.1666C12.4649 12.2229 12.47 12.2778 12.4732 12.3334H9.84118C9.85295 12.2238 9.86027 12.1129 9.86027 12.0001C9.86027 10.3431 8.54841 9.00021 6.93014 9.00021C5.31186 8.99989 4 10.3431 4 12.0001C4 13.6571 5.31186 15 6.93014 15H15.4545C16.9067 14.9132 18 13.6751 18 12.1666Z",
    fill: "url(#paint1_linear_1310_6464)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78296 11.3235C9.48291 9.99279 8.32123 8.99989 6.93014 8.99989C6.50919 8.99989 6.10987 9.09246 5.7481 9.25607C5.6711 9.49007 5.62782 9.7395 5.62782 9.99986C5.62782 11.2885 6.64823 12.3331 7.90696 12.3331C8.68523 12.3334 9.37187 11.9333 9.78296 11.3235Z",
    fill: "url(#paint2_linear_1310_6464)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9768 13.6667C14.0446 13.6667 15.7209 11.9505 15.7209 9.83336C15.7209 7.71625 14.0446 6 11.9768 6C9.90904 6 8.23277 7.71625 8.23277 9.83336C8.23277 11.9505 9.90904 13.6667 11.9768 13.6667Z",
    fill: "url(#paint3_linear_1310_6464)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78004 7.84468C8.43482 8.42486 8.23245 9.10404 8.23245 9.83304C8.23245 10.6713 8.49845 11.4447 8.94422 12.0756C9.68082 11.689 10.1858 10.9056 10.1858 9.99986C10.1861 9.02818 9.60541 8.19568 8.78004 7.84468Z",
    fill: "url(#paint4_linear_1310_6464)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26586 9.33257C8.24454 9.49649 8.23245 9.66332 8.23245 9.83335C8.23245 10.6716 8.49813 11.4444 8.94391 12.0753C8.9455 12.0744 8.94741 12.0737 8.949 12.0731C9.12877 11.9782 9.29454 11.8593 9.44282 11.7211C9.45554 11.7092 9.467 11.6957 9.47941 11.6832C9.53604 11.6279 9.59045 11.57 9.64136 11.509C9.66363 11.4823 9.68368 11.4537 9.70468 11.426C9.73141 11.3907 9.75654 11.3544 9.78136 11.3177C9.58409 10.4508 9.01963 9.72985 8.26586 9.33257Z",
    fill: "url(#paint5_linear_1310_6464)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4652 12.1666C12.4652 12.6751 12.5979 13.1511 12.8267 13.5635C14.4844 13.1688 15.7209 11.6504 15.7209 9.83304C15.7209 9.67779 15.7091 9.52576 15.6916 9.37533C15.542 9.34961 15.3893 9.33322 15.2325 9.33322C13.7042 9.33322 12.4652 10.6019 12.4652 12.1666Z",
    fill: "url(#paint6_linear_1310_6464)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1310_6464",
    x1: 5.55782,
    y1: 9.99729,
    x2: 12.0729,
    y2: 10.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1310_6464",
    x1: 3.90264,
    y1: 11.984,
    x2: 15.7797,
    y2: 12.0458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1310_6464",
    x1: 7.93528,
    y1: 15.0601,
    x2: 7.41935,
    y2: 5.45702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1310_6464",
    x1: 2.78773,
    y1: 16.673,
    x2: 16.0014,
    y2: 7.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1310_6464",
    x1: 13.533,
    y1: 9.78772,
    x2: 6.71613,
    y2: 10.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1310_6464",
    x1: 11.848,
    y1: 17.4946,
    x2: 6.88417,
    y2: 6.22721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#1797E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#0A85D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1310_6464",
    x1: 7.14713,
    y1: 20.104,
    x2: 15.5526,
    y2: 9.51385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgICloud);
export default __webpack_public_path__ + "static/media/ICloud.dd8c5b5a330070b09b646562d7bb85e0.svg";
export { ForwardRef as ReactComponent };